module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_6000.e66e5168.png";